import type { ESQueryModel } from '@repo/api-codegen';
import { useContext } from 'react';
import { useNavigate } from 'react-router';
import {
	QueryDrawerContext,
	defaultContext,
	type QueryDrawerContextType,
} from '../types';

export const useQueryDrawer = (): QueryDrawerContextType => {
	const context = useContext(QueryDrawerContext);
	const navigate = useNavigate();

	if (context === defaultContext) {
		return {
			...context,
			openQuery: (query: ESQueryModel | null) =>
				navigate(query?.id ? `/query/${query.id}` : 'queries'),
		};
	}

	return context;
};
